// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 2107 ? "vendor.prosemirror-tables" : chunkId) + "." + {"2107":"ddc2e2ec73e96964c718","6980":"ccba80ef3ec569aadac7"}[chunkId] + ".js";
};